import { useCallback } from 'react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { configureCobalt, fetchCobaltConfig } from '../../../services/queries/MaggieIntegrationsQueries';
import { CobaltFormValues } from './cobaltConfig.schema';

export function useCobaltConfigActions() {
  const queryClient = useQueryClient();

  const { data, isLoading } = useQuery({
    queryKey: ['cobalt-config'],
    queryFn: fetchCobaltConfig,
  });

  const mutation = useMutation({
    mutationFn: configureCobalt,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['cobalt-config'] });
    },
  });

  const config = data ?? null;
  const isConnected = config?.isConnected ?? false;
  const apiKeyLast4 = config?.config?.apiKeyLast4 ?? null;

  const saveConfig = useCallback(
    async (values: CobaltFormValues) => {
      return mutation.mutateAsync({ apiKey: values.apiKey.trim() || undefined });
    },
    [mutation]
  );

  const resetConfig = useCallback(async () => {
    await queryClient.invalidateQueries({ queryKey: ['cobalt-config'] });
  }, [queryClient]);

  return { config, isConnected, apiKeyLast4, isLoading, saveConfig, resetConfig };
}
